<template>
    <div class="inner-page">
        <Header v-if="$route.name === 'candidate.results'" />
        <main class="inner-page__content  align-items-stretch  p-0">
            <div class="exam  w-100">
                <Sidebar />
                <TransitionTemplate>
                    <router-view />
                </TransitionTemplate>
            </div>
        </main>
        <Footer />
    </div>
</template>

<script>
    import Header from "./Header";
    import Sidebar from "./Sidebar";
    import Footer from "./Footer";
    import TransitionTemplate from "../../../components/TransitionTemplate";
    
    export default {
        name: "MainLayout",
        components: { TransitionTemplate, Footer, Sidebar, Header }
    }
</script>

<style scoped>

</style>
